import React from 'react';
import ContentSection from '../ContentSection';
import css from './insights.less';
import NewVsReturningCustomersData from './NewVsReturningCustomersData';

type State = any;


export default class NewVsReturningCustomers extends React.PureComponent<{}, State> {

    state = {year: (new Date).getFullYear()};

    changeYear = (val: any) => {
        // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'year' implicitly has an 'any' typ... Remove this comment to see the full error message
        this.setState(({year}) => ({year: year + val}));
    };

    render() {

        return (
            <ContentSection title="New vs Returning Customers" storageKey="reports-insights-new-vs-returning-customers"
                            className="no-scroll">
                {/* @ts-expect-error ts-migrate(2769) FIXME: Property 'year' does not exist on type 'IntrinsicA... Remove this comment to see the full error message */}
                <NewVsReturningCustomersData year={this.state.year} changeYear={this.changeYear}/>
                <p className={css.reportHelpText}>
                    <strong>New:</strong> Customer's first confirmed booking was created in the chosen year.<br/>
                    <strong>Returning: </strong> Customer has a confirmed booking in the given year <em>and</em> a
                    previous year.
                </p>
            </ContentSection>
        )
    }
}
